import { render, staticRenderFns } from "./NeoInput.vue?vue&type=template&id=20be10c7&scoped=true&"
import script from "./NeoInput.vue?vue&type=script&lang=ts&"
export * from "./NeoInput.vue?vue&type=script&lang=ts&"
import style0 from "./NeoInput.vue?vue&type=style&index=0&id=20be10c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be10c7",
  null
  
)

export default component.exports